module.exports = __webpack_public_path__ + "static/media/ic-logout.21d1f186.svg";